import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);
const API_URL = process.env.REACT_APP_API_URL || '/api';

export const API = axios.create({ baseURL: API_URL, timeout: 15000 });

API.interceptors.request.use(cfg => {
  const t = localStorage.getItem('tmaster_token');
  if (t) cfg.headers.Authorization = 'Bearer ' + t;
  return cfg;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('tmaster_token');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    /* 402 = plan khatam. Account band hai, par login khula hai —
       aadmi ko seedha renew wale page par le jaate hain. */
    if (err.response && err.response.status === 402 && err.response.data && err.response.data.expired) {
      if (!window.location.pathname.startsWith('/renew')) window.location.href = '/renew';
    }
    return Promise.reject(err);
  }
);

export function AuthProvider({ children }) {
  const [user, setUser]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tmaster_token');
    if (token) {
      API.get('/auth/me')
        .then(r => setUser(r.data.user))
        .catch(() => localStorage.removeItem('tmaster_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (phone, password, directToken, directUser) => {
    // OTP flow: token + user provided directly
    if (directToken && directUser) {
      localStorage.setItem('tmaster_token', directToken);
      if (directUser.permissions && typeof directUser.permissions === 'string') {
        try { directUser.permissions = JSON.parse(directUser.permissions); } catch {}
      }
      setUser(directUser);
      return { token: directToken, user: directUser };
    }
    // Password flow
    const r = await API.post('/auth/login', { phone: String(phone).trim(), password });
    localStorage.setItem('tmaster_token', r.data.token);
    setUser(r.data.user);
    toast.success(r.data.message || 'Login successful!');
    return r.data;
  };

  const register = async (data) => {
    const r = await API.post('/auth/register', data);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem('tmaster_token');
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const r = await API.get('/auth/me');
      setUser(r.data.user);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export const useAPI  = () => API;

/* Supplier ka module purane data me 'transporters' naam se bhi pada hai.
   Backend dono ko ek hi maanta hai; screen bhi maane, warna Suppliers ka
   menu aur uske button chup-chaap gayab ho jaate hain. */
var PERM_ALIAS = { suppliers:'transporters', transporters:'suppliers' };

/* Staff ko is module par ye kaam karne ki ijaazat hai ya nahi.

   Backend se bilkul milta hua hona chahiye. Pehle do jagah farak tha:
   permissions khaali object {} ho (saare tick hata diye gaye) to backend
   "sirf dekho" kehta tha par screen poora menu gayab kar deti thi. Ab
   khaali {} aur NULL — dono ka ek hi matlab: sirf dekho. */
export function usePermission(module, action) {
  var { user } = useContext(AuthContext);
  if (!user) return false;
  if (user.role === 'admin') return true;                 // owner ko sab
  var perms = user.permissions;
  if (!perms || !Object.keys(perms).length) return action === 'view';
  var p = perms[module] || perms[PERM_ALIAS[module]];
  if (!p) return false;
  return !!p[action];
}
